import { Dispatch } from 'redux';
import {
  getAboutUs,
  getCategoryPriceList,
  getFooterCategories,
  subscribeToNewsLetter,
} from './service';
import { getSeoFooterCategories } from '@nykaa/seo/store/service';
import { logger } from '@nykaa/logger';
import footerActionTypes from './actionTypes';

export interface NewsletterParams {
  email: string;
}
// if need to addd more action type please move them in a separate file
const SEND_NEWSLETTER_SUCCESS = 'footer/send_newsletter';

export const sendNewsletter =
  (params: NewsletterParams) => (dispatch: Dispatch) =>
    subscribeToNewsLetter(params)
      .then((response) => {
        dispatch({
          type: SEND_NEWSLETTER_SUCCESS,
        });
        return response;
      })
      .catch((error) => {
        logger.error(error, 'Error Subscribing to news letter');
        return false;
      });

export const fetchCategoryPriceListing =
  (params: any) => (dispatch: Dispatch) =>
    getCategoryPriceList(params)
      .then((priceList) => {
        dispatch({
          type: footerActionTypes.FETCH_PRICE_LIST,
          payload: priceList,
        });
        return priceList;
      })
      .catch((err) => {
        logger.error(err, 'Error in Fetch Category Price List action');
      });

export const fetchSeoFooterCategories = (params: any) => (dispatch: Dispatch) =>
  getSeoFooterCategories(params)
    .then((response) => {
      dispatch({
        type: footerActionTypes.FETCH_FOOTER_CATEGORIES,
        payload: response,
      });
      return response;
    })
    .catch((err) => {
      logger.error(err, 'Error in Fetch Footer Categories List action');
    });

export const fetchFooterCategories = (params: any) => (dispatch: Dispatch) =>
  getFooterCategories(params)
    .then((response) => {
      dispatch({
        type: footerActionTypes.FETCH_FOOTER_CATEGORIES,
        payload: response,
      });
      return response;
    })
    .catch((err) => {
      logger.error(err, 'Error in Fetch Footer Categories List action');
    });

export const fetchAboutUs = (params: any) => (dispatch: Dispatch) =>
  getAboutUs(params)
    .then((response) => {
      dispatch({
        type: footerActionTypes.FETCH_ABOUT_US,
        payload: response,
      });
      return response;
    })
    .catch((err) => {
      logger.error(err, 'Error in Fetch About Us List action');
    });
